/**
 * @flow
 * @relayHash 1b9c1baa7ebed80dc5ebd580949d238c
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type PayWithAmazonInput = {|
  orderId: string,
  sessionId: string,
|};
export type PayWithAmazonMutationVariables = {|
  input: PayWithAmazonInput
|};
export type PayWithAmazonMutationResponse = {|
  +payWithAmazon: ?{|
    +order: ?{|
      +id: string,
      +orderid: ?string,
      +state: ?string,
    |}
  |}
|};
export type PayWithAmazonMutation = {|
  variables: PayWithAmazonMutationVariables,
  response: PayWithAmazonMutationResponse,
|};
*/


/*
mutation PayWithAmazonMutation(
  $input: PayWithAmazonInput!
) {
  payWithAmazon(input: $input) {
    order {
      id
      orderid
      state
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "PayWithAmazonInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "payWithAmazon",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "PayWithAmazonPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "order",
        "storageKey": null,
        "args": null,
        "concreteType": "Order",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "orderid",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "state",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "PayWithAmazonMutation",
    "type": "RootMutationType",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "PayWithAmazonMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "PayWithAmazonMutation",
    "id": null,
    "text": "mutation PayWithAmazonMutation(\n  $input: PayWithAmazonInput!\n) {\n  payWithAmazon(input: $input) {\n    order {\n      id\n      orderid\n      state\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'ff17a341a0bd7981b23712619cca6805';

module.exports = node;
